import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import { colors } from 'vuetify/lib';

Vue.use(Vuetify);

const opts =
{
    customVariables: ['../assets/variables.scss'],
    theme: {
    dark: false,
    themes: {
      dark: {
        primary: colors.blue.darken2,
        accent: colors.grey.darken3,
        secondary: colors.amber.darken3,
        info: colors.teal.lighten1,
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3
      },
      light: {
        primary: '#00aeef',
        secondary: '#00aeef',
        accent: '#00aeef',
        error: '#d82821',
        info: '#00aeef',
        success: '#73d821',
        warning: '#d82821'
      }
    }
  }
};

export default new Vuetify(opts)